import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Radio extends PureComponent {
  render() {
    const { className, ...others } = this.props;
    const cls = classNames({
      "weui-check": true
    }, className);

    return (
      <>
        <input className={ cls } type="radio" { ...others } />
        <i className="weui-icon-checked"></i>
      </>
    );
  }
}
